import { SmoEnvironment } from '../../../Models/Smo/SmoEnvironment';
import { TensorFlowImageClassifier } from '../TensorFlowImageClassifier';

export class SmoEnvironmentImageClassifier extends TensorFlowImageClassifier<SmoEnvironment> {
  public constructor() {
    super('/smo-environment-classifier');
  }
}
